export default __webpack_public_path__ + "static/media/image10.a666045d.jpeg";